import { lazy } from 'react';

/**
 * Public Routes Configuration
 * All routes are lazy-loaded for better performance
 */

// Lazy load all page components
const Home = lazy(() => import('../pages/home/Home'));
const OurMission = lazy(() => import('../pages/courses/OurMission'));
const OurBoard = lazy(() => import('../pages/courses/OurBoard'));
const Madarasa = lazy(() => import('../pages/courses/Madarasa'));
const QuranReading = lazy(() => import('../pages/courses/QuranReading'));
const QuranMemorization = lazy(() => import('../pages/courses/QuranMemorization'));
const MarriageService = lazy(() => import('../pages/services/MarriageService'));
const Contact = lazy(() => import('../pages/contact/Contact'));
const VideoLinks = lazy(() => import('../pages/videos/VideoLinks'));
const LocalBusinesses = lazy(() => import('../pages/locals/LocalBusinesses'));
const Funeral = lazy(() => import('../pages/funeral/Funeral'));
const FAQ = lazy(() => import('../pages/faq/FAQ'));

/**
 * Public routes array
 * Each route object contains path and lazy-loaded component
 */
const publicRoutes = [
  {
    path: '/',
    element: Home,
    index: true,
  },
  {
    path: '/about/mission',
    element: OurMission,
  },
  {
    path: '/about/board',
    element: OurBoard,
  },
  {
    path: '/services/madarasa',
    element: Madarasa,
  },
  {
    path: '/services/quran-reading',
    element: QuranReading,
  },
  {
    path: '/services/quran-memorization',
    element: QuranMemorization,
  },
  {
    path: '/services/marriage',
    element: MarriageService,
  },
  {
    path: '/videos',
    element: VideoLinks,
  },
  {
    path: '/local-businesses',
    element: LocalBusinesses,
  },
  {
    path: '/funeral-services',
    element: Funeral,
  },
  {
    path: '/contact',
    element: Contact,
  },
  {
    path: '/faq',
    element: FAQ,
  },
];

export default publicRoutes;
